<template>
  <div class="container">
    <div class="handle-box">
      <el-button type="primary" icon="el-icon-plus" @click="addActor">添加</el-button>
    </div>
    <el-tabs v-model="query.type" @tab-click="tabClick" type="card">
      <el-tab-pane :name="item.value" :key="index" v-for="(item, index) in menuType" :label="item.label"
        :index:="index">
      </el-tab-pane>
    </el-tabs>
    <el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header">
      <el-table-column property="ID" label="ID" align="center" width="50"></el-table-column>
      <el-table-column property="name" label="角色名" align="center" width="200"></el-table-column>
      <el-table-column property="type" label="角色类型" width="200" align="center">
        <template #default="scope">
          <el-tag v-if="scope.row.type === 0" type="success">平台类型角色</el-tag>
          <el-tag v-if="scope.row.type === 1" type="danger">加盟商类型角色</el-tag>
          <el-tag v-if="scope.row.type === 2" type="warn">代理商类型角色</el-tag>
        </template>
      </el-table-column>
      <el-table-column property="memo" label="备注" align="center"></el-table-column>
      <el-table-column property="CreatedAt" label="添加时间" width="170" :formatter="dateFormat"></el-table-column>
      <el-table-column label="操作" width="230" header-align="center">
        <template #default="scope">
          <el-button type="text" icon="el-icon-edit" @click="handleMenu(scope.$index, scope.row)">角色菜单
          </el-button>
          <el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">编辑
          </el-button>
          <el-button type="text" icon="el-icon-delete" class="red" @click="handleDelete(scope.row.ID)">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handlePageChange" :current-page="query.page"
        :page-sizes="[10, 20, 50, 100, 200]" :page-size="10" layout="total,sizes, prev, pager, next" :total="pageTotal">
      </el-pagination>
    </div>
    <el-dialog :title="actTitle" width="40%" v-model="editVisible">
      <el-form ref="form" :model="form" class="el-dialog__body model-h">
        <el-form-item label=" 角色名称" required>
          <el-input v-model="form.name" style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label=" 角色类型" required>
          <el-select v-model="form.type" placeholder="请选择" style="width: 200px;">
            <el-option v-for="item in actorType" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label=" 角 色 备 注 ">
          <el-input v-model="form.memo" type="textarea" style="width: 400px" placeholder="请输入角色备注"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="editVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveEdit">确 定</el-button>
        </span>
      </template>
    </el-dialog>
    <el-drawer title="编辑角色菜单" v-model="menuVisible" :direction="direction" :before-close="handleClose">
      <div class="menu-box">
        <el-tree :data="allMenu" show-checkbox node-key="ID" :default-expanded-keys="allMenu" ref="tree"
          :default-checked-keys="menuData" @check-change="handleCheckChange" :props="defaultProps">
        </el-tree>
      </div>
      <div style="margin-top: 10px;float: right;margin-right: 50px;">
        <el-button @click="menuVisible = false">取 消</el-button>
        <el-button type="primary" @click="editMenu">确 定</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { getActorList, setActor, removeActor, actorDetail, setActorMenu } from "@/api/actor";
import { getAllMenu } from "@/api/menu";

export default {
  name: "ActorTable",
  data() {
    return {
      tableData: [],
      query: {
        page: 1,
        pageSize: 10,
        is_validate: null
      },
      pageTotal: 0,
      actTitle: '添加',
      editVisible: false,
      form: {},
      actorType: [
        { value: 0, label: '平台类型角色' },
        { value: 1, label: '加盟商类型角色' },
        { value: 2, label: '代理商类型角色' },
      ],
      menuType: [
        { label: '平台', value: 0 },
        { label: '加盟商', value: 1 },
        { label: '代理商', value: 2 }
      ],
      menuVisible: false,
      menuData: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      allMenu: [],
      menuForm: {
        id: null,
        menus: []
      }
    }
  },
  created() {
    this.getData()
  },
  methods: {
    dateFormat: function (row, column) {
      const date = row[column.property];
      if (date === undefined) {
        return "";
      }
      var time = new Date(date).toJSON();
      return new Date(new Date(time) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
    },
    getData() {
      getActorList(this.query).then(res => {
        this.tableData = res.data.list
        if (this.query.page === 1) {
          this.pageTotal = res.data.total
        }
      })
    },
    handleSearch() {
      this.query.page = 1
      this.getData()
    },
    // 每页大小变化
    handleSizeChange(val) {
      this.query.page_size = val
      this.getData()
    },

    // 分页导航
    handlePageChange(val) {
      this.query.page = val
      this.getData()
    },

    addActor() {
      this.actTitle = "添加"
      this.form = {}
      this.editVisible = true
    },

    handleEdit(index, row) {
      this.actTitle = "编辑"
      this.editVisible = true
      this.form = row
      this.form.id = row.ID
    },

    saveEdit() {
      this.form.id = Number(this.form.id)
      setActor(this.form.id, JSON.stringify(this.form)).then(res => {
        if (res.code == 0) {
          this.$message.success(res.msg)
          this.editVisible = false
          this.getData()
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    handleDelete(id) {
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          removeActor(JSON.stringify({ id })).then(res => {
            if (res.code == 0) {
              this.$message.success(res.msg)
              this.getData()
            } else {
              this.$message.error(res.msg)
            }
          })
        })
    },

    handleMenu(index, row) {
      this.menuForm.menus = []
      this.menuForm.id = row.ID
      actorDetail(row.ID).then(res => {
        let checkedMenu = []
        let roleMenu = []
        res.data.menus.forEach(val => {
          if(val.path!=''){
            checkedMenu.push(val)
            roleMenu.push(val.ID)
          }
        })
        setTimeout(() => {
          this.$refs.tree.setCheckedNodes(checkedMenu)
            this.menuData = checkedMenu
            roleMenu.forEach(item => {
              this.menuForm.menus.push({ id: item })
            })
          }, 1000)
      })
      getAllMenu(this.query).then(res => {
        if (res.code == 0) {
          this.allMenu = res.data
        }
      })
      setTimeout(() => {
        this.menuVisible = true
      }, 1000)
    },
    editMenu() {
      setActorMenu(JSON.stringify(this.menuForm)).then(res => {
        if (res.code == 0) {
          this.$message.success(res.msg)
          this.menuVisible = false
          this.getData()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    handleCheckChange(data, checked) {
      if (checked) {
        this.menuForm.menus.push({ id: data.ID })
      } else {
        this.menuForm.menus = this.menuForm.menus.filter(item => item.id !== data.ID)
      }
    },
    tabClick() {
      this.getData()
    },
  }
}
</script>

<style scoped>
.select {
  margin-bottom: 10px;
}

.handle-box {
  margin-bottom: 10px;
}

.avatar {
  height: 180px;
  display: block;
}

.handle-input {
  width: 200px;
  display: inline-block;
}

.mr10 {
  margin-right: 10px;
}

.el-select {
  width: 120px;
}

.red {
  color: #ff0000;
}

.menu-box {
  height: 80vh;
  overflow-y: scroll;
}
</style>